export function newId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `el_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
